import { useEffect, useState } from 'react'
import { IndexableBlogPost } from '@/components/SearchBox/SearchBox'

const normalizeBlogPost = (post: IndexableBlogPost): IndexableBlogPost => ({
  sys: {
    createdAt: post.sys.createdAt,
  },
  fields: {
    ...post.fields,
    title: post.fields.title || '',
    keywords: Array.isArray(post.fields.keywords)
      ? post.fields.keywords
      : post.fields.keywords
        ? [post.fields.keywords]
        : [],
  },
})

export const useSearchableBlogPosts = () => {
  const [blogPosts, setBlogPosts] = useState<IndexableBlogPost[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - This will be present once you've run the app locally
    import('../../public/blog-index.json')
      .then(data => {
        const normalized = data.default.map(normalizeBlogPost)
        setBlogPosts(normalized)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return { blogPosts, isLoading }
}
